import { useEffect, useState } from "react";
import { rawMaterials } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import { RegistryHeader } from "../../common/Shared";

const AllStocks = () => {
  const [loading, setLoading] = useState(false);
  const [grouped, setGrouped] = useState({});

  const normalizeStock = (data) => {
    const result = [];
    data?.forEach((categoryObj) => {
      const category = Object.keys(categoryObj)[0];
      const rows = categoryObj[category] || [];
      rows.forEach((row) => {
        result.push({
          category,
          sku: row.skU_NO,
          material: row.materiaL_NAME,
          grade: row.grade,
          supplier: row.supplier_Name,
          qty: Number(row.quantity || 0),
          amount: Number(row.amount || 0),
          unit: row.unit_Name,
        });
      });
    });
    return result;
  };

  const groupByCategory = (items) => {
    return items.reduce((acc, item) => {
      (acc[item.category] = acc[item.category] || []).push(item);
      return acc;
    }, {});
  };

  const fetchStock = async () => {
    setLoading(true);
    try {
      const res = await rawMaterials.getAllStock();
      const flat = normalizeStock(res?.data || []);
      setGrouped(groupByCategory(flat));
    } catch (err) {
      notify("Error fetching stock", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStock();
  }, []);

  return (
    <div className="flex flex-col h-full bg-white font-plus overflow-hidden">
      <RegistryHeader title="Stock Inventory" />

      <div className="px-8 pt-0 pb-8 flex-1 overflow-auto relative">
        {loading && <Loader centered />}

        {Object.keys(grouped).length > 0 ? (
          <div className="space-y-8 mt-2">
            {Object.keys(grouped).map((cat) => {
              const rows = grouped[cat];
              const totalQty = rows.reduce((t, r) => t + (r.qty || 0), 0);
              const totalAmount = rows.reduce((t, r) => t + Number(r.amount || 0), 0);
              const avgAmount = totalQty > 0 ? totalAmount / totalQty : 0;

              return (
                <div key={cat} className="bg-white border border-gray-200  overflow-hidden">
                  <div className="bg-gray-50/50 px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div>
                      <h3 className="text-[12px] font-black text-gray-800 uppercase tracking-[2px]">
                        {cat}
                      </h3>
                      <p className="text-[9px] text-gray-400 font-bold uppercase tracking-widest mt-1">
                        {rows.length} Items in this category
                      </p>
                    </div>
                    <div className="flex items-center gap-8 text-right">
                      <div className="flex flex-col">
                        <span className="text-[8px] font-black text-gray-400 uppercase tracking-[2px] mb-1">
                          TOTAL QTY
                        </span>
                        <span className="text-[20px] font-black text-slate-800 leading-none">
                          {totalQty.toLocaleString()} <span className="text-[9px] text-gray-400 font-bold uppercase tracking-widest">UNIT</span>
                        </span>
                      </div>
                      <div className="w-[1px] h-8 bg-gray-200"></div>
                      <div className="flex flex-col">
                        <span className="text-[8px] font-black text-gray-400 uppercase tracking-[2px] mb-1 text-[#3F80F7]">
                         Avg Rate
                        </span>
                        <span className="text-[20px] font-black text-[#3F80F7] leading-none">
                          {avgAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="overflow-x-auto">
                    <Table
                      columns={[
                        { key: "sku", label: "SKU" },
                        { key: "material", label: "Material Name" },
                        { key: "grade", label: "Grade" },
                        { key: "supplier", label: "Supplier" },
                        {
                          key: "qty",
                          label: "Qty",
                          render: (val) => <span className="font-black text-gray-900">{val}</span>,
                        },
                        { key: "unit", label: "Unit" },
                      ]}
                      data={rows}
                      showActions={false}
                      tableClassName="text-[12px] font-bold"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          !loading && (
            <div className="bg-white py-32 text-center">
              <div className="text-gray-200 text-6xl mb-6">📦</div>
              <h3 className="text-[14px] font-black text-gray-400 uppercase tracking-[3px]">
                 No Stock Data Found
              </h3>
              <p className="text-[11px] text-gray-300 mt-2 font-bold uppercase tracking-widest">
                Try refreshing the page or check back later.
              </p>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default AllStocks;
